/**
 * Types et palette des motifs de visite. La couleur est un nom fermé
 * (miroir de l'enum back `VisitReasonColor`) : ce fichier est le SEUL endroit
 * qui la traduit en classes Tailwind.
 */

export type VisitReasonColor =
  | "SLATE"
  | "BLUE"
  | "CYAN"
  | "EMERALD"
  | "AMBER"
  | "ORANGE"
  | "VIOLET"
  | "PINK"
  | "RED";

/** Motif renvoyé par `/visit-reasons/lookup` et la liste paginée. */
export interface VisitReasonApi {
  id: number;
  label: string;
  color: VisitReasonColor;
  displayOrder: number;
  activated: boolean;
}

/** Corps de `POST` / `PUT /visit-reasons`. */
export interface VisitReasonPayload {
  label: string;
  color: VisitReasonColor;
  displayOrder?: number;
  activated?: boolean;
}

type ColorStyle = {
  /** Libellé français, pour le choix de couleur dans l'écran de gestion. */
  name: string;
  /** Pastille : fond + texte + bordure. */
  badge: string;
  /** Point plein (choix de couleur, motif sélectionné). */
  dot: string;
};

// Classes écrites en entier : Tailwind ne détecte pas les noms construits dynamiquement.
export const VISIT_REASON_COLOR_STYLES: Record<VisitReasonColor, ColorStyle> = {
  SLATE: { name: "Gris", badge: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-500" },
  BLUE: { name: "Bleu", badge: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500" },
  CYAN: { name: "Cyan", badge: "bg-cyan-50 text-cyan-700 border-cyan-200", dot: "bg-cyan-500" },
  EMERALD: { name: "Vert", badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  AMBER: { name: "Ambre", badge: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  ORANGE: { name: "Orange", badge: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  VIOLET: { name: "Violet", badge: "bg-violet-50 text-violet-700 border-violet-200", dot: "bg-violet-500" },
  PINK: { name: "Rose", badge: "bg-pink-50 text-pink-700 border-pink-200", dot: "bg-pink-500" },
  RED: { name: "Rouge", badge: "bg-red-50 text-red-700 border-red-200", dot: "bg-red-500" },
};

export const VISIT_REASON_COLORS = Object.keys(VISIT_REASON_COLOR_STYLES) as VisitReasonColor[];

/** Couleur inconnue (back plus récent que le client) → gris neutre. */
export const colorStyle = (color?: string | null): ColorStyle =>
  VISIT_REASON_COLOR_STYLES[color as VisitReasonColor] ?? VISIT_REASON_COLOR_STYLES.SLATE;

/** Longueurs maximales, alignées sur la validation back. */
export const VISIT_REASON_LABEL_MAX_LENGTH = 80;
export const REASON_NOTE_MAX_LENGTH = 255;
